<!-- <div [class]="'chartContainerNPS-'+idn" style="width: 100%; height: 100%" #chartContainerNPS >
</div> -->

<div [class]="idn" style="width: 100%; height: 100%" #chartContainer [id]="idn"></div>

